import MealUpgradeDecisionModal from './MealUpgradeDecisionModal';

export const isMealUpgradeChoiceRequired = error => (
  error?.response?.status === 409
  && error?.response?.data?.code === 'MEAL_UPGRADE_EXTRA_FOODS'
  && Array.isArray(error?.response?.data?.extraFoods)
);

export const beginMealUpgrade = async ({
  activityId,
  backendService,
  modalService,
  onUpgraded,
}) => {
  try {
    const upgraded = await backendService.upgradeActivity(activityId);
    onUpgraded(upgraded);
    return upgraded;
  } catch (error) {
    if (!isMealUpgradeChoiceRequired(error)) throw error;

    await new Promise(resolve => {
      let settled = false;
      const onSettled = () => {
        if (settled) return;
        settled = true;
        resolve();
      };
      modalService.open(MealUpgradeDecisionModal, {
        extraFoods: error.response.data.extraFoods,
        onSettled,
        onChoose: async extraFoodChoice => {
          const upgraded = await backendService.upgradeActivity(activityId, {
            extraFoodChoice,
            expectedRevision: error.response.data.revision,
          });
          onUpgraded(upgraded);
          return upgraded;
        },
      });
    });
    return null;
  }
};
